/* Mostly copied from https://github.com/i18next/react-i18next/tree/master/example/react */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // load translation via http request from /public/locales; https://github.com/i18next/i18next-http-backend
  .use(Backend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    // supportedLngs: ['en-CA', 'fr-CA'], // also make sure to load locale for moment in initializeLocales
    supportedLngs: ['en-CA'],
    // for all options read: https://www.i18next.com/overview/configuration-options
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    fallbackLng: 'en-CA',
    debug: false,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p']
    }
  });

/**
 * Note: Before using this function outside scope of react ie regular JS files,
 * make sure that the translation of namespace is loaded before hand
 * @param namespace is the namespace of the tFunction
 * @returns tFunction associated to the namespace
 */
export const getTFunction = (namespace: string | string[]) => {
  const { language } = i18n;
  return i18n.getFixedT(language, namespace);
};

export const getRouteTFunction = () => {
  const { language: lang } = i18n;

  /**
   * Cloning the instance here to update the default name spacepace separator from ":" to  "|"
   * So that the tFunction doesn't have to pass it everytime it is used
   */
  const tFunction = i18n.cloneInstance({ nsSeparator: '|' }).getFixedT(lang, 'routes');

  return tFunction;
};

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js